module.exports = __webpack_public_path__ + "img/1000091582.d955b8ae.jpg";